import { AreaCode } from '@ebalance/proto/bfftypes/v1/area_pb'

/**
 * OCCTO 5 桁コードの末尾 1 桁 (数値) → AreaCode 変換。
 *
 * 北海道〜九州 = 1〜9、 沖縄 = 0 (= AreaCode.OKINAWA の enum 値は 10 だが
 * OCCTO 末尾桁は '0')。 backend `AreaCodeFromOcctoSuffix` と同等の写像。
 *
 * BG コード / 取引先コード等、 OCCTO 5 桁コード体系を持つマスタで共用する
 * (AC-BG13 / AC-OMT-022)。
 */
export function areaCodeFromTrailingDigit(
  trailingDigit: number,
): AreaCode | undefined {
  switch (trailingDigit) {
    case 0:
      return AreaCode.OKINAWA
    case 1:
      return AreaCode.HOKKAIDO
    case 2:
      return AreaCode.TOHOKU
    case 3:
      return AreaCode.TOKYO
    case 4:
      return AreaCode.CHUBU
    case 5:
      return AreaCode.HOKURIKU
    case 6:
      return AreaCode.KANSAI
    case 7:
      return AreaCode.CHUGOKU
    case 8:
      return AreaCode.SHIKOKU
    case 9:
      return AreaCode.KYUSHU
    default:
      return undefined
  }
}
